import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import React, { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { object, string } from 'yup';
import { PASSENGER_DETAILS } from '../../../brands/default/content/components/checkout';
import { addContactNumber, isTravelValid } from '../../../helpers/basketTravel';
import { validatePhone } from '../../../helpers/validations';
import ThemeContext from '../../../providers/ThemeProvider';
import { setIsTravel, setIsTravelValid } from '../../../redux/actions/checkout';
import InputForm from '../../_generic/input/Input';
import Tile from '../../_generic/tile/Tile';
import Passenger from './Passenger';

const PassengerDetails = ({ dealId, product }) => {
  const theme = useContext(ThemeContext);
  const dispatch = useDispatch();
  const storageKey = `passengerContactPhone-${dealId}`;
  const formik = useFormik({
    initialValues: {
      contactNo: localStorage.getItem(storageKey) || '',
    },
    validationSchema: object().shape({
      contactNo: string()
        .required('Required')
        .test((value) => {
          return validatePhone(value);
        }),
    }),
  });
  const { handleChange, touched, handleBlur, values, errors, isValid } = formik;

  useEffect(() => {
    if (product && values && values.contactNo) {
      addContactNumber(product, isValid, values.contactNo);
      dispatch(setIsTravelValid(isTravelValid(product)));
    }
  }, [product, values]);

  useEffect(() => {
    dispatch(setIsTravel(true));
  }, []);

  // update storage
  const updateStorage = (event) => {
    handleBlur(event);
    localStorage.setItem(storageKey, values.contactNo);
    addContactNumber(product, isValid, values.contactNo);
    dispatch(setIsTravelValid(isTravelValid(product)));
  };

  return (
    <div className="passenger-details">
      <Tile title={PASSENGER_DETAILS.heading}>
        <div className="passenger-details__row">
          <p className="passenger-details__note">{PASSENGER_DETAILS.note}</p>
          <p className="passenger-details__required">
            {PASSENGER_DETAILS.required}
          </p>
        </div>
        <div className="passenger-details">
          {[...new Array(product.quantity)].map((event, index) => (
            <Passenger
              dealId={dealId}
              key={`passenger-${dealId}-${index}`}
              number={index + 1}
              product={product}
            />
          ))}
        </div>
        <div className="passenger-details__contact">
          <h3 className="passenger-details__subheading">
            {PASSENGER_DETAILS.labelContactNo}
          </h3>
          <InputForm
            error={errors.contactNo && touched.contactNo}
            inputValue={values.contactNo}
            maxLength={20}
            name="contactNo"
            onBlurFunction={(event) => {
              updateStorage(event);
            }}
            onChangeFunction={handleChange}
            placeholder={PASSENGER_DETAILS.placeholderContactNo}
            type="text"
          />
        </div>
      </Tile>
      <style jsx>{`
        .passenger-details :global(.tile) {
          width: 100%;
        }
        .passenger-details {
          display: flex;
          flex-wrap: wrap;
          align-content: stretch;
        }
        .passenger-details__row,
        .passenger-details__contact {
          display: flex;
          padding: 15px 15px 0 15px;
        }
        .passenger-details__required {
          margin-left: auto;
        }
        .passenger-details__contact {
          width: 50%;
          display: block;
          padding-bottom: 15px;
        }
        @media (max-width: ${theme.breakpoints.mdDown}) {
          .passenger-details__contact {
            width: 100%;
          }
        }
      `}</style>
    </div>
  );
};

PassengerDetails.propTypes = {
  dealId: PropTypes.number.isRequired,
  product: PropTypes.object.isRequired,
};

export default PassengerDetails;
